import * as types from "../actions/actionTypes";

const initialState = {
  otp: null,
};

const otp = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_OTP: return { ...state, otp: null };
    case types.CREATE_OTP: return { ...state, otp: null };
    default:
      return state;
  }
};

export default otp;
